import React from 'react'
import Moment from 'moment'

const SyncDate = ({ lastSyncedAt }) => {
  const date = lastSyncedAt ? Moment(lastSyncedAt, 'YYYY-MM-DD') : null

  return date ? (
    <div className="syncButton--lastSyncedDate">
      Last fetched <time dateTime={date.toISOString()}> {date.fromNow()} </time>
    </div>
  ) : null
}

export default SyncDate



// WEBPACK FOOTER //
// ./src/ui/sync-button/views/sync-date.jsx